import { render, staticRenderFns } from "./SubpoenasList.vue?vue&type=template&id=4660ae38&"
import script from "./SubpoenasList.vue?vue&type=script&lang=js&"
export * from "./SubpoenasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports